import {
  Box,
  Typography,
  Modal,
  CircularProgress,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

const UserSubscriptionDetailsModal = ({ userId, onClose }) => {
  const [subscriptionData, setSubscriptionData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchSubscriptionData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `/user-subcriptions-detials/?user_id=${userId}`
        );
        console.log(response?.data?.response, "reponse");
        setSubscriptionData(response?.data?.response || []);
      } catch (error) {
        console.error("Error fetching subscription details:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchSubscriptionData();
  }, [userId]);
  return (
    <Modal open={true} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          //   width: 400,
          bgcolor: "background.paper",
          border: "2px solid #000",
          boxShadow: 24,
          p: 4,
          pr: 1,
          maxHeight: "80vh",
          overflowY: "auto",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": {
            display: "none", 
          },
        }}
      >
        <Box
          sx={{ position: "absolute", top: 8, right: 8, cursor: "pointer" }}
          onClick={onClose}
        >
          <CloseIcon />
        </Box>
        <Typography variant="h6" gutterBottom>
          User Details
        </Typography>
        {loading ? (
          <CircularProgress />
        ) : (
          subscriptionData.map((subscription) => (
            <Box key={subscription.id} mb={4}>
              <Typography variant="subtitle1" gutterBottom>
                Subscription ID: {subscription.id}
              </Typography>
              <Typography>
                Amount: {subscription.amount} {subscription.currency}
              </Typography>
              <Typography>
                Payment Date:{" "}
                {new Date(subscription.payment_date).toLocaleDateString()}
              </Typography>
              <Typography>
                Payment End Date: {subscription.payment_end_date}
              </Typography>
              <Typography>Invoice: {subscription.invoice_numebr}</Typography>
              <Typography>Payment ID: {subscription.payment_id}</Typography>
              <Typography>
                Alerts Used: {subscription.used_alerts} /{" "}
                {subscription.total_alerts}
              </Typography>

              <Typography variant="subtitle2" mt={2} gutterBottom>
                Plan Details:
              </Typography>

              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Plan Name</TableCell>
                    <TableCell>Plan Code</TableCell>
                    <TableCell>Price</TableCell>
                    <TableCell>Interval</TableCell>
                    <TableCell>Alerts</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {subscription?.plan_details?.map((plan) => (
                    <TableRow key={plan.id}>
                      <TableCell>{plan.name}</TableCell>
                      <TableCell>{plan.plan_code}</TableCell>
                      <TableCell>{plan.price}</TableCell>
                      <TableCell>
                        {plan.interval} {plan.interval_unit}
                      </TableCell>
                      <TableCell>{plan.alert}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          ))
        )}
      </Box>
    </Modal>
  );
};

export default UserSubscriptionDetailsModal;
